import React from "react";
import { Artist } from "../spotify/spotify";

interface ArtistListProps {
    artists: Artist[];
}

const ArtistList: React.FC<ArtistListProps> = ({ artists }) => (
    <div className="column-centered">
        <div className="column track-list">
            { 
                artists.map(artist => (
                    <div key={artist.id} className="row align-center mx-bw-5 my-2 md:my-3">
                        { artist.images.length > 0 && <img src={artist.images[0].url} alt="img" className="album-art-img" /> }
                        <p className="flex-grow text-xl text-center">{artist.name}</p>
                    </div>
                ))
            }
        </div>
    </div>
);

export default ArtistList;
